import { Grid, Stack } from '@mui/material';
import { Button, CloseIcon, CompleteIcon } from '@uy3/web-components';
import { AutocompleteOptionList } from 'components/Forms/Autocomplete';
import { SelectFormField } from 'components/Forms/FormFields';
import AutocompleteField from 'components/Forms/FormFields/AutocompleteField/AutocompleteField';
import { useFormContext } from 'contexts/formContext';
import { activeTheme } from 'services/theme';

const palette = activeTheme().palette;

type ShareRecordProps = {
    onClose: () => void;
    principalAutocomplete: AutocompleteOptionList;
}

export const ShareRecord = ({ onClose, principalAutocomplete }: ShareRecordProps) => {
    const { watch } = useFormContext();
    const principalTypeValue = watch('principalType');
    return (
        <Stack spacing={2}>

            <Grid>
                <SelectFormField
                    label='Tipo de permissão'
                    name='principalType'
                    fullWidth
                    required={true}
                    options={[
                        { label: 'Usuário', value: 'User' },
                        { label: 'Grupo', value: 'Group' },
                        { label: 'Tenant', value: 'Tenant' }
                    ]}
                />
            </Grid>

            {principalTypeValue && (
                <>
                    <Grid>
                        <AutocompleteField
                            label={watch('principalTypeDisplay') ?? "Registro"}
                            name='principalId'
                            displayName='principalIdDisplay'
                            required={true}
                            {...principalAutocomplete}
                        />
                    </Grid>

                    <Grid>
                        <SelectFormField
                            label='Nível de permissão'
                            name='permissionLevelType'
                            fullWidth
                            required={true}
                            options={[
                                { label: 'Visualizar', value: 'View' },
                                { label: 'Editar', value: 'Edit' }
                            ]}
                        />
                    </Grid>
                </>
            )}

            <Stack direction="row" spacing={2} justifyContent="right" alignItems="center">
                <Button
                    variant="outlined"
                    startIcon={<CloseIcon htmlColor={palette.primary.main} />}
                    onClick={onClose}
                >
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    startIcon={<CompleteIcon htmlColor={palette.common.white} />}
                    type="submit"
                >
                    Continuar
                </Button>
            </Stack>
        </Stack>
    )
}
